import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5 8.5V9.3C12.5 10.4201 12.5 10.9802 12.282 11.408C12.0903 11.7843 11.7843 12.0903 11.408 12.282C10.9802 12.5 10.4201 12.5 9.3 12.5H3.7C2.57989 12.5 2.01984 12.5 1.59202 12.282C1.21569 12.0903 0.909734 11.7843 0.717987 11.408C0.5 10.9802 0.5 10.4201 0.5 9.3V8.5M9.83333 5.16667L6.5 8.5M6.5 8.5L3.16667 5.16667M6.5 8.5V0.5",
		stroke: "white",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDownload;
